'use client';

import { WidgetInstance } from 'friendly-challenge';
import classnames from 'classnames';
import { useEffect } from 'react';

import { useSchemes, useSuspensions } from '@personly/libs-providers';

import { useRecaptchas } from '@/providers/recaptchas';

interface Props {
  captchaKey: string;
  locale: string;
}

const Recaptcha = ({ captchaKey, locale }: Props) => {
  const { setSolution, container, widgetRef } = useRecaptchas();

  const { createSuspension, removeSuspension } = useSuspensions();
  const { displaySchemeHandle } = useSchemes();

  useEffect(() => {
    if (!widgetRef.current && container.current) {
      const instance = new WidgetInstance(container.current, {
        startMode: 'auto',
        startedCallback: () => {
          createSuspension('CAPTCHA');
        },
        errorCallback: () => {
          removeSuspension('CAPTCHA');
        },
        doneCallback: (solution) => {
          removeSuspension('CAPTCHA');
          setSolution(solution);
        },
      });

      widgetRef.current = instance;
    }

    return () => {
      if (widgetRef.current !== undefined) widgetRef.current!.reset();
    };
  }, [createSuspension, removeSuspension, setSolution, container, widgetRef]);

  const scheme = displaySchemeHandle.toLowerCase();

  return (
    <div
      ref={container}
      className={classnames(
        scheme,
        '!relative',
        '!w-full',
        '!bg-input-background-color',
        '!border',
        '!border-input-border-color',
        '!rounded'
      )}
      data-sitekey={captchaKey}
      data-lang={locale}
    />
  );
};

export default Recaptcha;
